import * as React from "react";
import {styled} from "@mui/material/styles";
import Avatar from "@mui/material/Avatar";
import MuiDrawer, {drawerClasses} from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import SelectContent from "./SelectContent";
import MenuContent from "./MenuContent";
import OptionsMenu from "./OptionsMenu";
import {useAuthInfo} from "@/store/account.c";
import {colors} from "@/helper/constant";
import {randomArrayItem} from "@/helper/method";
import {useWindowSize} from "@/helper/hooks";
import {useMemo} from "react";


const DrawerWrapper = styled(MuiDrawer, {shouldForwardProp: (prop) => prop !== "drawerWidth"})<{ drawerWidth?: number }>(({drawerWidth}) => ({
    width: drawerWidth,
    flexShrink: 0,
    boxSizing: "border-box",
    mt: 10,
    [`& .${drawerClasses.paper}`]: {
        width: drawerWidth,
        boxSizing: "border-box",
    },
}));

const ScrollMenuWrapper = styled(Box)(() => ({
    height: "100%",
    display: "flex",
    paddingLeft: 6,
    paddingRight: 0,
    flexDirection: "column",
    overflowY: "scroll",
    "::-webkit-scrollbar": {
        width: 7,
        height: 7,
    },
    "::-webkit-scrollbar-thumb": {
        [`& .${drawerClasses.paper}`]: {
            backgroundColor: "background.paper",
        },
        cursor: "pointer",
        borderRadius: "3px",
    },
    "&:hover::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(231,231,226,0.84)",
    },
}));

export default function SideMenu() {
    const authInfo = useAuthInfo();
    const {innerWidth} = useWindowSize()
    const drawerWidth = useMemo(() => {
        if (innerWidth >= 1600) {
            return 280
        }
        if (innerWidth < 1600 && innerWidth >= 1300) {
            return 250
        }
        return 228
    }, [innerWidth]);

    return (
        <DrawerWrapper
            variant="permanent"
            drawerWidth={drawerWidth}
            sx={{
                zIndex: 999,
                display: {xs: "none", md: "block"},
                [`& .${drawerClasses.paper}`]: {
                    backgroundColor: "background.paper",
                },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    mt: "calc(var(--template-frame-height, 0px))",
                    p: 1.5,
                }}
            >
                <SelectContent/>
            </Box>
            <Divider/>
            <ScrollMenuWrapper>
                <MenuContent/>
            </ScrollMenuWrapper>
            <Stack
                direction="row"
                sx={{
                    p: 2,
                    gap: 1,
                    alignItems: "center",
                    borderTop: "1px solid",
                    borderColor: "divider",
                }}
            >
                <Avatar
                    sizes="small"
                    alt={authInfo?.username?.substring(0, 1)}
                    src={authInfo?.avatar}
                    sx={{width: 36, height: 36, backgroundColor: randomArrayItem(colors)}}
                />
                <Box sx={{mr: "auto"}}>
                    <Typography
                        variant="body2"
                        sx={{fontWeight: 500, lineHeight: "16px"}}
                    >
                        {authInfo?.username}
                    </Typography>
                    <Typography variant="caption" sx={{color: "text.secondary"}}>
                        {authInfo?.account}
                    </Typography>
                </Box>
                <OptionsMenu/>
            </Stack>
        </DrawerWrapper>
    );
}
